<mat-sidenav-container class="sidenav">
  <mat-sidenav #sidenav [opened]="model.open" (keydown.escape)="close()" mode="over" fixedInViewport="true"
    position="end">
    <div #header class="sidenav-header header-title" fxFlex="none" fxLayout="row" fxLayoutAlign="space-between center">
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
        <div class="title">{{ "message.notificationCentral.title" | translate }}</div>
      </div>
      <div fxFlex fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="end center" >
        <div class="read-all" (click)="markAllAsRead()" fxLayoutAlign="center center">
          <mat-icon aria-hidden="false" [matTooltip]="'message.notificationCentral.markAllAsRead' | translate" class="icon-read-all ic-svg-dark-9"
          svgIcon="icon_read_all"></mat-icon>
        </div>
        <div class="close" (click)="close()" color="warn" fxLayoutAlign="center center">
          <mat-icon aria-hidden="false" aria-label="Filter">close</mat-icon>
        </div>
      </div>
    </div>
    <div appearance="outlined" fxLayout="row" fxLayout.lt-md="column" class="service-container no-padding">
      <div fxFlex="100" class="sidebar" fxLayout.lt-md="row">
        <div fxFlex="100" class="notification-list" *ngIf="this.model.emptyState == false">
          <div fxFlex="100" fxLayout="column-reverse" class="notification-group">
            <div fxFlex="100" fxLayout="column" *ngFor="let dateKey of getNotificationDates()">
              <div fxFlex="100" fxLayout="row" fxLayoutGap="18px" class="date">
                <div class="spacer"></div>
                <div class="value">{{ dateKey }}</div>
                <div class="spacer"></div>
              </div>
              <div class="notifications-list">
                <div class="notification" *ngFor="let notification of groupedNotifications[dateKey]">
                  <!-- Notificacoes reports -->
                  <mat-card fxFlex="100" fxLayout="row" class="notification-card reports" (click)="markAsRead(notification.report_request_id); loadContent( notification.report_request_id); markAsRead(notification.report_request_id);">
                    <div class="reports" fxFlex="100" fxLayout="row" fxLayoutGap="16px" *ngIf="notification.report_type_desc">
                      <div class="button-div">
                        <div  *ngIf="notification.isReport != false && notification.report_status == 'R'" [ngClass]="{ hideFab: notification.report_status != 'R'}" fxLayout="row" fxLayoutAlign="start center"
                        fxFlexAlign="center">
                          <app-layout-fab-button
                            [id]="notification.report_request_id"
                            [icon]="'refresh'"
                            [hasSpinner]="true"
                            [spinnerTime]="5"
                            (timeComplete)="loadContent(notification.report_request_id)"
                            (onClick)="loadContent(notification.report_request_id); markAsRead(notification.report_request_id);"
                          ></app-layout-fab-button>
                        </div>
                      <div class="download-icon" *ngIf="notification.report_status == 'D'" (click)="download(notification.partner, notification.account, notification.merchant, notification.report_request_id)">
                        <mat-icon class="ic-svg-dark-6" aria-hidden="false" aria-label="download" svgIcon="icon_share"></mat-icon>
                      </div>
                      <div class="error-icon" *ngIf="notification.report_status == 'E'">
                        <mat-icon aria-hidden="false" aria-label="status" class="icon-status ic-svg-white" svgIcon="icon_error"></mat-icon>
                      </div>
                        <div class="badge-notify" *ngIf="!notification.read"></div>
                      </div>
                      <div class="info">
                        <div class="description" *ngIf="notification.report_type_desc">{{ notification.report_type_desc }}</div>
                        <div class="path" *ngIf="notification.report_path">{{ 'tuna-reports' + notification.report_path.split('tuna-reports')[1] }}</div>
                      </div>
                    </div>

                    <div class="general-notifications" fxFlex="100" fxLayout="row" fxLayoutGap="16px" *ngIf="!notification.report_type_desc" (click)="openUrl(notification.urlPath)">
                      <div class="button-div">
                        <div class="icon-notification-general" [style.background-color]="notification.bgColorIcon" xLayout="row" fxLayoutAlign="start center"
                        fxFlexAlign="center">
                          <mat-icon aria-hidden="false" aria-label="icon-notification" class="icon-notification-svg" [style.color]="notification.iconColor" [svgIcon]="notification.svgIcon"></mat-icon>
                        </div>
                        <div class="badge-notify" *ngIf="!notification.read"></div>
                      </div>
                      <div class="info">
                        <div class="description" *ngIf="notification.title">{{ notification.title }}</div>
                        <div class="path" *ngIf="notification.subtitle">{{ notification.subtitle }}</div>
                      </div>
                    </div>
                  </mat-card>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="empty-state" *ngIf="this.model.emptyState == true">
          <div>{{ "message.notificationCentral.noNotification" | translate }}</div>
        </div>
      </div>
    </div>
  </mat-sidenav>
</mat-sidenav-container>
